import React from 'react';
import { Badge } from '@atoms';

export interface RoleStatusBadgeProps {
  isActive: boolean;
}

export const RoleStatusBadge: React.FC<RoleStatusBadgeProps> = ({ isActive }) => {
  return (
    <Badge
      variant={isActive ? 'success' : 'error'}
      size="sm"
    >
      {isActive ? 'Active' : 'Inactive'}
    </Badge>
  );
};
